import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { login } from "../actions/auth";
import { Navigate } from "react-router-dom";
import logo from "../assets/LogoGrande.png";

import "../styles/login.scss";

const AuthPage = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [formAlerts, setFormAlerts] = useState({
    email: false,
    password: false,
    non_auth: false,
  });
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const checkEmptyFields = () => {
    let isEmpty = false;
    const newFormData = { ...formData };

    Object.keys(formData).forEach((key) => {
      if (formData[key].trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }
      setTimeout(() => {
        setFormAlerts({
          email: false,
          password: false,
        });
      }, 3500);
    });

    setFormData(newFormData);
    return isEmpty;
  };
  const onLogin = (e) => {
    e.preventDefault();
    if (!checkEmptyFields()) {
      const { email, password } = formData;
      dispatch(login(email, password)).catch((error) => {
        setFormAlerts((prev) => ({ ...prev, non_auth: true }));
      });
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }
  return (
    <div className="login-page ">
      <div className="login-header d-flex justify-content-center">
        <img src={logo} alt="Logo Saudeki Grande" />
      </div>
      <div className="login-body d-flex flex-column justify-content-center">
        <Form.Group
          className="mb-3 login-input-group"
          controlId="formBasicEmail"
        >
          <Form.Label>Email</Form.Label>
          <Form.Control
            className={formAlerts.email ? "border border-danger" : ""}
            name="email"
            type="email"
            placeholder="Ingresar email"
            onChange={(e) => onChange(e)}
          />
          <span
            className={
              formAlerts.email ? "fst-italic m-2 text-danger" : "d-none"
            }
          >
            Campo no valido o vacio.
          </span>
        </Form.Group>

        <Form.Group
          className="mb-3 login-input-group"
          controlId="formBasicPassword"
        >
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            className={formAlerts.email ? "border border-danger" : ""}
            name="password"
            type="password"
            placeholder="Contraseña"
            onChange={(e) => onChange(e)}
          />
          <span
            className={
              formAlerts.password ? "fst-italic m-2 text-danger" : "d-none"
            }
          >
            Campo no valido o vacio.
          </span>
        </Form.Group>

        <span
          className={
            formAlerts.non_auth ? "fst-italic m-2 text-danger" : "d-none"
          }
        >
          Autenticacion Fallida, compruebe las credenciales.
        </span>
        <Button variant="primary" type="submit" onClick={onLogin}>
          Ingresar
        </Button>
      </div>
    </div>
  );
};

export default AuthPage;
